/* eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react';
import useLocales from 'src/hooks/useLocales';
import Loader from 'src/components/loader/Loader';

import { IRentPayment } from 'src/@types/Choqorak/MainTables/RentPayment.ts/RentPayment';
import { GetMonthName } from 'src/sections/common/GetMonthName';
import { ShopReportData, ShopReportEntry } from 'src/@types/Choqorak/MainTables/Shop/Shop';
import { ICustomerDetails } from 'src/@types/Choqorak/MainTables/Contract/Customer';
import { baseUrl } from 'src/api/baseUrl';
import { email } from './../../../../../../_mock/email';

type Props = {
  CustomerDetails?: ICustomerDetails;
};

export default function CustomerPDF({ CustomerDetails }: Props) {
  const { translate } = useLocales();
  const [dirction, setDirection] = useState('ltr');

  const lang = localStorage.getItem('i18nextLng');
  const language = window.localStorage.getItem('i18nextLng');
  useEffect(() => {
    if (lang === 'ps' || lang === 'dr') {
      setDirection('rtl');
    } else {
      setDirection('ltr');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dirction]);

  if (!CustomerDetails) {
    return <Loader />;
  }

  const thStyle = `table-th-Attandence-Report text-[12px]`;

  const tdStyle = `table-td-Attandence-Report text-[11px]`;

  const width = 'w-[240mm]';
  let Url = baseUrl;
  return (
    <div className="px-7">
      <div className={`${width} h-[297mm] mx-auto bg-white text-black`} dir={`${dirction}`}>
        <div className="page-break py-5 px-2">
          <div className="border-[2px] border-black pt-4 pb-2">
            <div className="flex justify-between items-center px-5">
              {/* Left Logo */}
              <div className="flex flex-col justify-center items-center text-center">
                <img
                  src={require('src/assets/Choqorak/logo1.png')}
                  width="100"
                  height="100"
                  alt="logo1"
                />
              </div>

              {/* Center Text */}
              <div className="text-base text-center font-bold print:text-base">
                <h3>چقرک مرکز پخش مواد خوراکی</h3>
                <h4>معلومات مشتری</h4>
              </div>

              {/* Right Logo */}
              <div className="flex flex-col justify-center items-center text-center">
                <img
                  src={require('src/assets/Choqorak/logo2.png')}
                  width="200"
                  height="400"
                  alt="logo2"
                />
              </div>
            </div>
          </div>
          <div className="max-w-5xl bg-white rounded-2xl  overflow-hidden min-h-[500px] p-6">
            <div className="flex items-center gap-6">
              <img
                className="w-40 h-40 rounded-xl border-4 border-indigo-500"
                src={Url + CustomerDetails.photoPath}
                alt="Customer" // Simplified alt text without redundant words like "photo"
              />
              <div>
                <table className="w-full border-collapse border-gray-300">
                  <tbody>
                    <tr className="bg-gray-50">
                      <th className=" px-4 py-2 text-left">
                        {' '}
                        {translate('Customer.CustomerName')}
                      </th>
                      <td className=" px-4 py-2">
                        {language === 'en'
                          ? CustomerDetails.englishFirstName + ' ' + CustomerDetails.englishSurName
                          : CustomerDetails.pashtoFirstName + ' ' + CustomerDetails.pashtoSurName}
                      </td>
                    </tr>
                    <tr>
                      <th className=" px-4 py-2 text-left"> {translate('Customer.FatherName')}</th>
                      <td className=" px-4 py-2">
                        {language === 'en'
                          ? CustomerDetails.englishFatherName
                          : CustomerDetails.pashtoFatherName}
                      </td>
                    </tr>
                    <tr className="bg-gray-50">
                      <th className=" px-4 py-2 text-left">
                        {translate('Customer.GrandFatherName')}
                      </th>
                      <td className=" px-4 py-2">
                        {language === 'en'
                          ? CustomerDetails.englishGrandFatherName
                          : CustomerDetails.pashtoGrandFatherName}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="mt-6 grid grid-cols-2 gap-4">
              <table className="w-full border-collapse border border-gray-300">
                <tbody>
                  <tr className="bg-gray-50">
                    <th className="border border-gray-300 px-4 py-2 text-left">
                      {' '}
                      {translate('Customer.PhoneNumber')}
                    </th>
                    <td className="border border-gray-300 px-4 py-2">
                      {CustomerDetails.phoneNumber}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-300 px-4 py-2 text-left">
                      {translate('Customer.EmergencyPhoneNumber')}
                    </th>
                    <td className="border border-gray-300 px-4 py-2">
                      {CustomerDetails.emergencyPhoneNumber}
                    </td>
                  </tr>
                  <tr className="bg-gray-50">
                    <th className="border border-gray-300 px-4 py-2 text-left">
                      {translate('Customer.Email')}
                    </th>
                    <td className="border border-gray-300 px-4 py-2">
                      {CustomerDetails.personalEmail}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-300 px-4 py-2 text-left">
                      {translate('Customer.Gender')}
                    </th>
                    <td className="border border-gray-300 px-4 py-2">{CustomerDetails.gender}</td>
                  </tr>
                  <tr>
                    <th className="border border-gray-300 px-4 py-2 text-left">
                      {translate('Customer.BloodGroup')}
                    </th>
                    <td className="border border-gray-300 px-4 py-2">
                      {CustomerDetails.bloodGroup}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-300 px-4 py-2 text-left">
                      {translate('Customer.DateOfBirth')}
                    </th>
                    <td className="border border-gray-300 px-4 py-2">
                      {CustomerDetails.dateOfBirth}
                    </td>
                  </tr>
                </tbody>
              </table>

              <table className="w-full border-collapse border border-gray-300">
                <tbody>
                  <tr className="bg-gray-50">
                    <th className="border border-gray-300 px-4 py-2 text-left">
                      {translate('Customer.TazkiraNo')}
                    </th>
                    <td className="border border-gray-300 px-4 py-2">
                      {CustomerDetails.tazkiraNo}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-300 px-4 py-2 text-left">
                      {translate('Customer.JoldNo')}
                    </th>
                    <td className="border border-gray-300 px-4 py-2">{CustomerDetails.joldNo}</td>
                  </tr>
                  <tr className="bg-gray-50">
                    <th className="border border-gray-300 px-4 py-2 text-left">
                      {translate('Customer.PageNo')}
                    </th>
                    <td className="border border-gray-300 px-4 py-2">{CustomerDetails.pageNo}</td>
                  </tr>
                  <tr>
                    <th className="border border-gray-300 px-4 py-2 text-left">
                      {translate('Customer.RegNo')}
                    </th>
                    <td className="border border-gray-300 px-4 py-2">{CustomerDetails.regNo}</td>
                  </tr>
                  <tr>
                    <th className="border border-gray-300 px-4 py-2 text-left">
                      {translate('Customer.MainProvinceName')}
                    </th>
                    <td className="border border-gray-300 px-4 py-2">
                      {CustomerDetails.mainProvince}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-300 px-4 py-2 text-left">
                      {translate('Customer.MainDistrict')}
                    </th>
                    <td className="border border-gray-300 px-4 py-2">
                      {CustomerDetails.mainDistrict}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-300 px-4 py-2 text-left">
                      {translate('Customer.PermanentAddress')}
                    </th>
                    <td className="border border-gray-300 px-4 py-2">
                      {CustomerDetails.permenantAddress}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-300 px-4 py-2 text-left">
                      {translate('Customer.CurrentProvinceName')}
                    </th>
                    <td className="border border-gray-300 px-4 py-2">
                      {CustomerDetails.currentProvince}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-300 px-4 py-2 text-left">
                      {translate('Customer.CurrentDistrict')}
                    </th>
                    <td className="border border-gray-300 px-4 py-2">
                      {CustomerDetails.currentDistrict}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-300 px-4 py-2 text-left">
                      {translate('Customer.TemporaryAddress')}
                    </th>
                    <td className="border border-gray-300 px-4 py-2">
                      {CustomerDetails.temporaryAddress}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            className={`print:fixed print:bottom-5 print:w-[230mm] print:mx-auto print:border-t-2 print:border-black text-[8pt] hidden print:block`}
          >
            <div className="px-5 relative w-full mx-auto" dir="ltr">
              <div className="flex justify-center items-center w-full">
                <img
                  src={require('src/assets/Choqorak/footer.png')}
                  width="500"
                  height="50"
                  alt="footer"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Show Summary ONLY on the Last Page */}
      </div>
    </div>
  );
}
